export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MM Queen Magnetics",
    "url": "https://mmqueen-magnetics.com",
    "logo": "https://mmqueen-magnetics.com/logo-192.png",
    "description": "Modularne magnetne ploščice za ustvarjalno igro otrok.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "51-268-847",
      "email": "tea@mmqueen.si",
      "contactType": "customer service",
      "availableLanguage": "Slovenian"
    },
    "sameAs": [
      "https://www.instagram.com/mmqueen.gifts/",
      "https://www.facebook.com/MMQueenTea"
    ]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function ProductSchema({ product }: { product: { name: string; description: string; imageUrl: string; slug: string; price: string } }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": product.imageUrl,
    "sku": product.slug,
    "brand": { "@type": "Brand", "name": "MM Queen Magnetics" },
    "offers": {
      "@type": "Offer",
      "price": product.price,
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": `https://mmqueen-magnetics.com/produkt/${product.slug}`,
      "seller": { "@type": "Organization", "name": "MM Queen Magnetics" }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "50",
      "bestRating": "5"
    }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function FAQSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Kaj so magnetne ploščice MM Queen?",
        "acceptedAnswer": { "@type": "Answer", "text": "MM Queen magnetne ploščice so modularne ravne, kvadratne in trikotne ploščice z magneti na robovih. Ko jih približate, se samodejno spojijo — brez lepila, brez sile, brez frustracije." }
      },
      {
        "@type": "Question",
        "name": "Za katero starost so primerne?",
        "acceptedAnswer": { "@type": "Answer", "text": "Ploščice so primerne za otroke od 3 let naprej. Imajo CE certifikat in so izdelane iz kvalitetne, otrokom varne plastike." }
      },
      {
        "@type": "Question",
        "name": "Ali so varne za otroke?",
        "acceptedAnswer": { "@type": "Answer", "text": "Da. Vse ploščice imajo CE certifikat in so testirane po evropskih varnostnih standardih za igrače." }
      },
      {
        "@type": "Question",
        "name": "Kako čistim ploščice?",
        "acceptedAnswer": { "@type": "Answer", "text": "Ploščice preprosto obrišite z vlažno krpo. Ne potapljajte jih v vodo." }
      }
    ]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
